import React, { useState, useEffect } from 'react';
import { PremiumOptionModal } from '../../Components/Modal/PremiumOptionModal';
import { useSelector } from 'react-redux';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { fetchGlobalAnalytics } from '../../Services/index.js';
import { Tooltip } from '@mui/material';
import { toast } from 'react-toastify';
import { trackPages } from '../../Utils/brevo';
import colors from '../../Utils/colors';
import images from '../../Utils/images';
import CheerioButton from '../../Components/CheerioButton';
import { MailRecordsCsv } from './MailRecordsCsv';
import { Modal, Box,Typography } from '@mui/material';
import { hiddenName, hiddenPhone } from '../ContactModule/ContactsAll/variableDependencies';
import {getLocaltime} from'../../Utils/localdate'
import BetaFeatureBanner from '../../Components/BetaFeatureBanner';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';


const ErrorJsonModal = ({ open, handleClose, rowData }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="error-json-modal"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxHeight: '80vh',
        bgcolor: 'background.paper',
        borderRadius: '8px',
        boxShadow: 24,
        p: 4,
        overflow: 'auto'
      }}>
        <Typography variant="h6" component="h2" mb={2}>
          Error Details
        </Typography>
        <pre style={{ 
          whiteSpace: 'pre-wrap', 
          wordWrap: 'break-word',
          backgroundColor: '#f5f5f5',
          padding: '15px',
          borderRadius: '4px',
          fontSize: '14px'
        }}>
          {JSON.stringify(rowData, null, 2)}
        </pre>
      </Box>
    </Modal>
  );
};

const GlobalAnalytics = ({ excepted }) => {
  const localdata = useSelector((state) => state.main.localdata);
  const isPremiumUser = localdata?.premium;
  const authtoken = useSelector((state) => state.main.auth_token);
  const [recordsData, setRecordsData] = useState([]);
  const [showMailRecords, setShowMailRecords] = useState(false);
  const agentdata = useSelector((state) => state.main.agentdata);
  const [pagination, setPagination] = useState({
    page: 0,
    limit: 20,
    totalRows: 1,
  });
  const [loading, setLoading] = useState(true);
  const [searchBy, setSearchBy] = useState('Name');
  const [searchQuery, setSearchQuery] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);


  const getData = () => {
    const data = {
      page: pagination.page, limit: pagination.limit, searchField: mapSearchField(searchBy),
      searchQuery: searchQuery
    };
    fetchGlobalAnalytics(data, authtoken)
      .then((res) => {
        if (res.flag) {
          setRecordsData(res?.data?.docs);
          console.log('res?.data?', res?.data);
          setPagination({
            ...pagination,
            totalRows: res?.data?.totalDocs ?? 0,
          });
          setLoading(false);
        } else {
          setLoading(false);
          toast.error('Something went wrong');
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error('Something went wrong');
      });
  };

  useEffect(() => {
    trackPages('analytics_global_analytics_page', localdata);
    if (agentdata && !agentdata?.permission?.globalAnalytics) {
      toast.error(
        'Feature access denied. Kindly request the owner to grant you permission to access this feature'
      );
      navigate('/creator');
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    getData();
  }, [pagination.page, pagination.limit, searchBy, searchQuery]);
  const mapSearchField = (field) => {
    switch (field) {
      case 'Name':
        return 'user_name';
      case 'Mobile':
        return 'phoneNumber';
      case 'Error':
        return 'errorLog';
      default:
        return '';
    }
  };
  const columns = [
    {
      field: 'user_name',
      headerName: 'Name',
      width: 180,
      valueFormatter: (params) => {
        return params?.value === '' ? 'NA' : params?.value;
      },
      renderCell: (params) => {
        return params?.value === '' ? 'NA' : excepted ? hiddenName(params?.value) : params?.value;
      },
      editable: false,
    },
    {
      field: 'phoneNumber',
      headerName: 'Mobile',
      width: 180,
      valueFormatter: (params) => {
        return params?.value === '' ? 'NA' : params?.value;
      },
      renderCell: (params) => {
        return excepted ? hiddenPhone(params?.value) : params?.value === '' ? 'NA' : params?.value;
      },
      editable: false,
    },
    {
      field: 'msg',
      headerName: 'Message',
      width: 180,
      valueFormatter: (params) => {
        return params?.value === '' ? 'NA' : params?.value;
      },
      renderCell: (params) => {
        <Tooltip
          sx={{
            '& .MuiTooltip-tooltip': {
              padding: '8px !important',
              borderRadius: '8px !important',
            },
          }}
          title={params.value}
        >
          <span>{params.value}</span>
        </Tooltip>;
      },
      editable: false,
    },
    {
      field: 'status_updatedAt.sentAt',
      headerName: 'Sent',
      type: 'string',
      width: 200,
      editable: false,
      valueGetter: (params) => {
        return params?.row?.status_updatedAt?.sentAt;
      },
      valueFormatter: (params) => params?.value ?? 'NA',
      renderCell: (params) => {
        if (!params?.value) return 'NA';    
        const formattedDate = getLocaltime(params?.value);
        return (
          <div
          style={{
            whiteSpace: 'normal',   
            wordWrap: 'break-word',     
          }}
          >
            {formattedDate}
          </div>
        );
    },            
    },
    {
      field: 'status_updatedAt.deliveryAt',
      headerName: 'Delivery',
      type: 'string',
      width: 200,
      editable: false,
      valueGetter: (params) => {
        return params?.row?.status_updatedAt?.deliveryAt;
      },
      valueFormatter: (params) => params?.value ?? 'NA',
      renderCell: (params) => {
        if (!params?.value) return 'NA';    
        const formattedDate = getLocaltime(params?.value);
        return (
          <div
          style={{
            whiteSpace: 'normal',   
            wordWrap: 'break-word',     
          }}
          >
            {formattedDate}
          </div>
        );
    },    
    },
    {
      field: 'status_updatedAt.readAt',
      headerName: 'Opened',
      type: 'string',
      width: 200,
      editable: false,
      valueGetter: (params) => {
        return params?.row?.status_updatedAt?.readAt;
      },
      valueFormatter: (params) => params?.value ?? 'NA',
      renderCell: (params) => {
        if (!params?.value) return 'NA';    
        const formattedDate = getLocaltime(params?.value);
        return (
          <div
          style={{
            whiteSpace: 'normal',   
            wordWrap: 'break-word',     
          }}
          >
            {formattedDate}
          </div>
        );
    },  
    },
    {
      field: 'status_updatedAt.clickAt',
      headerName: 'Click',
      type: 'string',
      width: 200,
      editable: false,
      valueGetter: (params) => {
        return params?.row?.status_updatedAt?.clickAt;
      },
      valueFormatter: (params) => params?.value ?? 'NA',
      renderCell: (params) => {
        if (!params?.value) return 'NA';    
        const formattedDate = getLocaltime(params?.value);
        return (
          <div
          style={{
            whiteSpace: 'normal',   
            wordWrap: 'break-word',       
          }}
          >
            {formattedDate}
          </div>
        );
      },
    },
    {
      field: 'errorLog',
      headerName: 'Error Log',
      width: 240,
      renderCell: (params) => {
        const errorValue = params?.row?.errorLog;
        
        // If errorValue is empty or NA, just show NA without the info button
        if (!errorValue || errorValue === 'NA') {
          return <span>NA</span>;
        }
    
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {/* <span style={{ 
              overflow: 'hidden', 
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '180px' // Adjust based on your needs
            }}>
              {errorValue}
            </span> */}
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedRowData(params?.row);
                setErrorModalOpen(true);
              }}
              sx={{ 
                padding: '4px',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)'
                }
              }}
            >
              <InfoIcon fontSize="small" />
            </IconButton>
          </div>
        );
      },
      editable: false,
    }
  ];

  return (
    <>
      {!isPremiumUser && (
        <PremiumOptionModal
          option={'Global Analytics'}
          openPremiumModal={true}
          setOpenPremiumModal={() => { }}
        ></PremiumOptionModal>
      )}

      <div className="announcement_container">
        <div className="announcement_container__header_container"          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '16px',
          }}
        >
          {/* Global Analytics Title */}
          <h3 style={{ margin: 0 }}>{'Global Analytics'}</h3>
          {/* <CheerioButton
                    borderStyle={{}}
                    textStyle={{ color: colors.white }}
                    btnText={'New Campaign'}
                    backColor={colors.black}
                    onclick={() => {
                        setOpenANModal(true);
                    }}
                    icon={images.IPlusWhite}
                /> */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              flexWrap: 'wrap',
            }}
          >
        {/* <BetaFeatureBanner 
          BannerText={"We are experiencing some issues in analytics and campaign data. Please do not re-run your campaigns. Inconvenience is regretted and issue will be resolved soon."}
        /> */}
          <div style={{ position: 'relative' }}>
            <button
              style={{
                backgroundColor: '#FAFAFA',
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '10px 12px',
                fontSize: '14px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              Search by: <span style={{ marginLeft: '8px', color: '#666666' }}>{searchBy}</span>
              <span style={{ marginLeft: '5px', fontSize: '10px' }}>▼</span>
            </button>
            {isDropdownOpen && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: '0',
                backgroundColor: 'white',
                border: '1px solid #ccc',
                borderRadius: '8px',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                zIndex: 1,
              }}>
                <div style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => { setSearchBy('Name'); setIsDropdownOpen(false); }}>Name</div>
                <div style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => { setSearchBy('Mobile'); setIsDropdownOpen(false); }}>Mobile</div>
                <div style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => { setSearchBy('Error'); setIsDropdownOpen(false); }}>Error</div>
              </div>
            )}
          </div>
          {/* Search Input */}
          <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
            <input
              type="text"
              placeholder="Search"
              style={{
                border: 'none',
                outline: 'none',
                padding: '10px',
                backgroundColor: '#FAFAFA',
                fontSize: '14px',
                flexGrow: 1,
              }}
              value={searchQuery}
              onChange={(e) => {
                const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
                setSearchQuery(sanitizedValue);
              }}
            />
            <button
              style={{
                backgroundColor: '#FAFAFA',
                border: 'none',
                padding: '8px 12px',
                cursor: 'pointer',
              }}
              onClick={() => getData()}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </button>
          </div>
          {/* Export Report Button */}
          {!excepted && (agentdata?.permission?.globalAnalyticsReport || !agentdata) && (
            <CheerioButton
                      textStyle={{
                         color: colors.black,
                        fontWeight: 600,
                        fontSize: '14px',
                      }}
                      btnText="Export Report"
                      icon={images.FILEEXPORT}
                      onclick={() => setShowMailRecords(true)}
                    />
          )}
          </div>
        </div>
        {showMailRecords && (
          <MailRecordsCsv show={showMailRecords} setShow={setShowMailRecords}></MailRecordsCsv>
        )}

        <div className="w-100 h-100 px-0" style={{ paddingInline: 0, paddingBlock: 20 }}>
          <DataGrid
            rows={recordsData}
            columns={columns}
            sx={styledSx}
            getRowId={(row) => row._id}
            loading={loading}
            // slots={{ toolbar: GridToolbar }}
            rowCount={pagination.totalRows}
            pageSizeOptions={[10, 20, 25, 50, 75, 100]}
            paginationMode="server"
            paginationModel={{
              page: pagination.page,
              pageSize: pagination.limit,
            }}
            initialState={{
              sorting: {
                sortModel: [{ field: 'name', sort: 'desc' }],
              },
            }}
            slotProps={{
              toolbar: {
                csvOptions: {
                  allColumns: true,
                  fields: ['Name', 'Mobile', 'Sent', 'Delivered', 'Opened', 'Clicked', 'Replied'],
                },
              },
            }}
            onPaginationModelChange={(params) => {
              setPagination({
                ...pagination,
                page: params.page,
                limit: params.pageSize,
              });
            }}
          />
        </div>
      </div>
      <ErrorJsonModal
        open={errorModalOpen}
        handleClose={() => setErrorModalOpen(false)}
        rowData={selectedRowData}
      />
    </>
  );
};

export default GlobalAnalytics;

 const styledSx = {
    '& ::-webkit-scrollbar': {
      width: '10px',
      height: '10px',
    },
    '& ::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
      borderRadius: '6px',
    },
    '& ::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',
      borderRadius: '6px',
      '&:hover': {
        backgroundColor: '#555',
      },
    },
    '& ::-webkit-scrollbar-corner': {
      backgroundColor: '#f1f1f1',
    },
 }
